module.exports = __webpack_public_path__ + "static/media/t-image2.d6770523.jpg";